module.exports = __webpack_public_path__ + "static/img/play.c8a6022.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/play.png
// module id = KBZJ
// module chunks = 1